import { api } from './client';

export interface SaveLocationRequest {
  latitude: number;
  longitude: number;
  accuracy: number;
}

export interface SaveLocationResponse {
  saved: boolean;
  reason?: 'interval';
  nextSaveAt?: string;
  lastSaveAt?: string;
  lastAccuracy?: number;
  location?: {
    id: string;
    latitude: number;
    longitude: number;
    accuracy: number;
    recordedAt: string;
  };
  goodAccuracy?: boolean;
}

export interface LocationStatusResponse {
  lastLocation: {
    latitude: number;
    longitude: number;
    accuracy: number;
    recordedAt: string;
  } | null;
  locationCount: number;
  nextSaveAt: string | null;
  canSaveNow: boolean;
  intervalMinutes: number;
  retentionDays: number;
}

export const locationApi = {
  saveLocation: async (data: SaveLocationRequest): Promise<SaveLocationResponse> => {
    const { data: response } = await api.post('/employees/location', data);
    return response;
  },

  getStatus: async (): Promise<LocationStatusResponse> => {
    const { data } = await api.get('/employees/location/status');
    return data;
  },
};
